import React from 'react';
import WXIMG from '../../../assets/trial_images/wxImg.png';

const CustomerWX = () => {
  return (
    <div>
      <div className="trial_wxBox">
        <img className="trial_wxBox_img" src={WXIMG} />
      </div>
      <div className="trial_wxText">微信扫一扫，联系客服</div>
    </div>
  );
};
export default CustomerWX;
